var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8675 0.525078C12.314 0.636702 12.5854 1.08915 12.4738 1.53564L9.14048 14.869C9.02886 15.3155 8.57641 15.5869 8.12992 15.4753C7.68342 15.3637 7.41195 14.9112 7.52358 14.4648L10.8569 1.13142C10.9685 0.684922 11.421 0.413454 11.8675 0.525078ZM5.58795 4.07761C5.91339 4.40305 5.91339 4.93068 5.58795 5.25612L2.84388 8.0002L5.58795 10.7443C5.91339 11.0697 5.91339 11.5973 5.58795 11.9228C5.26252 12.2482 4.73488 12.2482 4.40944 11.9228L1.07611 8.58945C0.750672 8.26402 0.750672 7.73638 1.07611 7.41094L4.40944 4.07761C4.73488 3.75217 5.26252 3.75217 5.58795 4.07761ZM14.4094 4.07761C14.7349 3.75217 15.2625 3.75217 15.588 4.07761L18.9213 7.41094C19.2467 7.73638 19.2467 8.26402 18.9213 8.58945L15.588 11.9228C15.2625 12.2482 14.7349 12.2482 14.4094 11.9228C14.084 11.5973 14.084 11.0697 14.4094 10.7443L17.1535 8.0002L14.4094 5.25612C14.084 4.93068 14.084 4.40305 14.4094 4.07761Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCode);
export default __webpack_public_path__ + "static/media/code.2600bac95911c1f825f0e99c4b1f597a.svg";
export { ForwardRef as ReactComponent };